import { jweixin } from '$utils/jweixin'
import guide from './wx-share-guide'
import LOGO from './logo'
import { resolveWX, rejectWX } from './type'

let hasAuth = false

const auth = () => {
  if (hasAuth) {
    return Promise.resolve()
  }
  return new Promise((resolve, reject) => {
    window.wx.ready(() => {
      hasAuth = true
      resolve()
    })
    jweixin().catch((e) => {
      reject(e)
    })
  })
}


export const setWechatShare = (title: string, content: string, url: string): Promise<resolveWX | rejectWX> => {
  return new Promise((resolve, reject) => {
    console.log('[分享 WX]', title, content, url)
    auth()
      .then(() => {
        const config = {
          title,
          desc: content, // 分享描述
          link: url, // 这个url，一定要是安全域名下的！！！要到pathname这层
          imgUrl: LOGO,
        }

        // 分享到朋友圈
        window.wx.onMenuShareTimeline({
          ...config,
          success() {
            resolve('pyq')
          }
        })
        // 分享给朋友
        window.wx.onMenuShareAppMessage({
          ...config,
          success() {
            resolve('weixin')
          }
        })
        // 分享到QQ
        window.wx.onMenuShareQQ({
          ...config,
          success() {
            resolve('qq')
          }
        })
        // qzone
        window.wx.onMenuShareQZone({
          ...config,
          success() {
            resolve('qzone')
          }
        })
      })
      .catch((e) => {
        reject(['error', e])
      })
  })
}

const share = (title: string, content: string, url: string) => {
  const guider = guide()
  return setWechatShare(title, content, url)
    .then((r) => {
      guider.emitClick()
      return r
    })
}

export default share